/**
 * Export default Block Gmaps JS
 * @uses {
 * - pluginGoogleMaps
 * }
 * @description Since most of the JS on this file is not needed ASAP, we lazy load this as a route
 */
export default {
	lazy: {
		id: ['google'],
		callback: () => {
			// ...as well as this small plugin
			import( /* webpackChunkName: "plugins/am2-GoogleMaps" */ "../../plugins/am2-GoogleMaps").then(() => {
				const { GoogleMap } = am2;
				GoogleMap.init(document.querySelectorAll('[data-plugin-google]'));
			});
		}
	}
}
